module.exports = __webpack_public_path__ + "img/experienceValueRed.0abf1273.jpg";